/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 *
 * Design System — Toast portal container
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — useSyncExternalStore is in React 18 runtime; @types/react is pinned to 17.x
import { useSyncExternalStore } from 'react';
import type { ToastItem } from '../../types';
import Banner from '../../components/Banner/Banner';
import { toastStore } from './toastStore';
import './ToastContainer.less';

/**
 * Renders the toast list inline (no portal).
 * The host element created by toast.ts acts as the portal anchor.
 */
export function ToastContainer() {
  const items: ToastItem[] = useSyncExternalStore(toastStore.subscribe, toastStore.getSnapshot);

  return (
    <div className="toast-container" aria-live="polite" aria-atomic="false">
      {items.map((item) => (
        <ToastEntry key={item.id} item={item} />
      ))}
    </div>
  );
}

function ToastEntry({ item }: { item: ToastItem }) {
  return (
    <div className="toast-container__item">
      <Banner
        type={item.type === 'loading' ? 'info' : item.type}
        title={typeof item.content === 'string' ? item.content : undefined}
        onClose={() => toastStore.remove(item.id)}>
        {typeof item.content !== 'string' ? item.content : undefined}
      </Banner>
    </div>
  );
}
